import { dnsnetInstance, purtvInstance } from "../instances/dnsnet_instance";

import { v4 } from "uuid";
import { differenceInMinutes } from "date-fns";

const sessionID = "d8f79fe3-c1ed-4fd7-bcb8-9f395c05d365" || v4();
let userData;
const epgData = {
  requestTime: undefined,
  subscribedPackage: undefined,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getUserToken() {
    let loginPromise;
    if (userData?.token) {
      loginPromise = Promise.resolve(userData);
    } else {
      loginPromise = this.login();
    }

    return loginPromise;
  },
  login() {
    return dnsnetInstance()
      .get(`login?udid=${sessionID}`, {
        auth: {
          username: "customerdelivery@foxxum.com",
          password: "123456",
        },
      })
      .catch((error) => {
        console.error(error);
      })
      .then((response) => {
        userData = response.data;
      })
      .catch((error) => {
        console.error(error);
      })
      .then(() => userData);
  },
  ping() {
    return this.getUserToken().then(({ token }) =>
      dnsnetInstance()
        .get("ping", {
          params: {
            token,
          },
        })
        .catch((error) => console.error(error))
    );
  },
  getPackages() {
    return this.getUserToken().then(({ token }) => {
      return dnsnetInstance()
        .get("packages", { params: { token } })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error(error);
        });
    });
  },
  getEpg() {
    if (
      epgData.requestTime &&
      differenceInMinutes(epgData.requestTime, new Date()) < 10
    ) {
      return Promise.resolve(epgData);
    }

    return this.getPackages().then((packagesResponse = { data: {} }) => {
      const { packages = [] } = packagesResponse.data;
      const subscribedPackage = packages.find((pkg) => pkg.subscribed);

      subscribedPackage?.channels?.sort(
        (ch1, ch2) => parseInt(ch1.pos, 10) - parseInt(ch2.pos, 10)
      );

      console.log("Sorted channels:", subscribedPackage?.channels);

      const cids = subscribedPackage?.channels
        ?.map((ch) => {
          ch.channelId = ch.cid.replace("c", "");
          return ch.channelId;
        })
        .join(",");

      const startts = Math.floor(new Date().getTime());
      const endts = startts + 10800 * 1000;

      return purtvInstance()
        .get(`/channels/${cids}/shows/startts/${startts}/endts/${endts}`, {
          headers: {
            Authorization: "Basic Zm94eHVtX3N3bV91c2VyOjgza1NqZCwhOSk",
          },
        })
        .then((epgResponse) => {
          epgResponse.data?.forEach((asset) => {
            const channel = subscribedPackage?.channels?.find(
              (ch) => ch.channelId === asset.channelId
            );

            if (!channel.assets) {
              channel.assets = [];
            }

            channel.assets.push(asset);
          });

          epgData.requestTime = new Date();
          epgData.subscribedPackage = subscribedPackage;
          return epgData;
        });
    });
  },
  getFirstChannelEPG() {
    return this.getEpg().then(
      ({ subscribedPackage }) => subscribedPackage?.channels?.[0]
    );
  },
  getChannelEPG(channelId) {
    return this.getEpg().then(({ subscribedPackage }) =>
      subscribedPackage?.channels.find((ch) => ch.channelId === channelId)
    );
  },
};
